var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24985 4.5V2.25C5.24985 1.83579 5.58564 1.5 5.99985 1.5H14.9999C15.4141 1.5 15.7499 1.83579 15.7499 2.25V12.75C15.7499 13.1642 15.4141 13.5 14.9999 13.5H12.7499V15.7493C12.7499 16.1639 12.4124 16.5 11.9948 16.5H3.005C2.58794 16.5 2.25 16.1666 2.25 15.7493L2.25195 5.25065C2.25202 4.83608 2.58948 4.5 3.00707 4.5H5.24985ZM6.74985 4.5H12.7499V12H14.2499V3H6.74985V4.5Z",
    fill: "#010103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.a74a136b89dbbced84aa71d7ad8d9890.svg";
export { ForwardRef as ReactComponent };